import styled, { css } from 'styled-components';

import { BackgroundColorType } from './PlaceholderCard';

import { Typography } from '@speeki/global-ui-components';

export const PlaceholderCardWrapper = styled.div<{
    backgroundColor?: BackgroundColorType;
    gridSize?: number;
    hidden?: boolean;
    minHeight?: number;
}>(
    ({
        backgroundColor,
        gridSize,
        hidden,
        minHeight,
        theme: { palette, radius },
    }) => css`
        background-color: ${palette.neutral.white};
        border-radius: ${radius[10]}px;
        display: flex;
        flex-direction: column;
        padding: 24px;
        position: relative;

        ${backgroundColor === 'secondary' &&
        css`
            background-color: ${palette.secondary.default};
        `}

        ${minHeight &&
        css`
            min-height: ${minHeight}px;
        `}

        ${gridSize &&
        css`
            grid-column: span ${gridSize};
        `}

        ${hidden &&
        css`
            display: none;
        `}
    `,
);

export const PlaceholderCardTitle = styled(Typography.TextH4_20_28)``;

export const PlaceholderCardDescription = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.secondary};
    `,
);

export const PlaceholderCardGrayText = styled(Typography.TextBody_12_18)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
    `,
);

export const BoldText = styled.span(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
    `,
);

export const RedText = styled.span(
    ({ theme: { palette } }) => css`
        color: ${palette.semantic.error};
    `,
);
